import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import enhanceWithClickOutside from 'react-click-outside';

class CreateDelivery extends Component{
  constructor(){
    super();
    this.state = {
      loading: false,
      message: null
    }

    this.createNewDelivery = this.createNewDelivery.bind(this)
  }

  handleClickOutside(event) {
    this.props.toggleCreateDelivery()
  }

  createNewDelivery() {
    this.setState({loading: true})
    const month_id = this.props.monthId
    const body = JSON.stringify({month_id});
    const token = localStorage.getItem("admin-token")
    const headers = { "Content-Type": "application/json",};
    headers["Authorization"] = `Token ${token}`;
    fetch("/api/klarna/delivery", {
      headers,
      body,
      method: "POST"
    })
      .then(res => {
        if (res.status === 200) {
          this.setState({
            message: "Delivery was created successfully",
            loading: false,
          })
        }  else {
          this.setState({
            message: "Server error",
            loading: false,
          })
        }
      })
  }

  render() {
    return(
      <div className="CreateDelivery">
        <h2>Create Delivery</h2>
        {
          this.state.message
          ?
          <div>
            <p>{this.state.message}</p>
            <Link to='/backoffice/deliveries'>View deliveries</Link>
            <button
              className="Cancel-btn"
              onClick={this.props.toggleCreateDelivery}>
              Close
            </button>
          </div>
          :
          <div>
            {
              this.state.loading
              ?
              <p>Loading...</p>
              :
              <div>
                <button
                  className="Create-btn"
                  onClick={this.createNewDelivery}>
                    Skapa ny
                </button>
                <button
                  className="Cancel-btn"
                  onClick={this.props.toggleCreateDelivery}>
                  Avbryt
                </button>
              </div>
            }
          </div>
        }
      </div>
    )
  }
}

export default enhanceWithClickOutside(CreateDelivery)



// WEBPACK FOOTER //
// ./src/containers/admin/components/CreateDelivery.jsx